// apiService.js
import axios from 'axios';

export function fetchCategories() {
  return axios.post('https://mh13.in/app/index.php/api/getCategories');
}

export function fetchEvents() {
  return axios.post('https://mh13.in/app/index.php/api/getEvents');
}

export function fetchNews() {
  return axios.post('https://mh13.in/app/index.php/api/getNews');
}

export function fetchJobs() {
  return axios.post('https://mh13.in/app/index.php/api/getJobs');
}

export function fetchFood() {
  return axios.post('https://mh13.in/app/index.php/api/getFood');
}

export function fetchListings() {
  return axios.post('https://mh13.in/app/index.php/api/getListings');
}

export function fetchProperties() {
  return axios.post('https://mh13.in/app/index.php/api/getProperties');
}

export function fetchUserProfile() {
  return axios.post('https://mh13.in/app/index.php/api/getUserProfile');
}

export function fetchRSS() {
  return axios.post('https://mh13.in/app/index.php/api/getRSS');
}

export function fetchTemperature() {
  return axios.post('https://mh13.in/app/index.php/api/getTemperature');
}

export function fetchDailyneeds() {
  return axios.post('https://mh13.in/app/index.php/api/getDailyNeeds');
}
export function fetchEmergencies() {
  return axios.post('https://mh13.in/app/index.php/api/getEmergencies');
}